import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["status", "match"]
  static values = { url: String }
  connect() { this.active = true; this.check() }
  disconnect() { this.active = false; clearTimeout(this.timer) }
  async check() {
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: 'application/json' }, cache: 'no-store' })
      if (!response.ok) throw new Error()
      const result = await response.json()
      if (!this.active) return
      if (result.discovery_url) {
        this.statusTarget.textContent = "You crossed paths with someone."
        this.matchTarget.href = result.discovery_url
        this.matchTarget.hidden = false
      } else if (result.processing) {
        this.statusTarget.textContent = "Your moment is saved. Checking for matches…"
        this.timer = setTimeout(() => this.check(), 3000)
      } else if (!result.has_location) {
        this.statusTarget.textContent = "This moment has no location, so it can’t find nearby matches. Allow location access for your next photo."
      } else {
        this.statusTarget.textContent = "No match yet. This moment can still connect you with someone later."
      }
    } catch {
      if (this.active) {
        this.statusTarget.textContent = "Your moment is saved. You can check for matches here later."
        this.timer = setTimeout(() => this.check(), 10000)
      }
    }
  }
}
